//
const weImage = require('common/ter/images/we_image.png')
// 公司简介
const corporateCulture01 = require('common/ter/images/corporate_culture_01.png')
const corporateCulture02 = require('common/ter/images/corporate_culture_02.png')
const corporateCulture03 = require('common/ter/images/corporate_culture_03.png')
// 发展史
const courseBackground = require('common/ter/images/course_background.png')
const content =
	'本司2018年成立于中国香港，我们风雨兼程历时多年打造核心团队，从自媒体运营到编程实验室，一路见证国内主内互联网行业的此起彼伏公司致力打造具有主内文化特色、以基督信仰生活为基础的新时代互联网生态的产品。根植信仰原则、福音使命、支持教会互联网新需求和倍增文化为目标砥砺前行。'
const data = {
	coverImg: weImage,
	detail: {
		title: '公司简介',
		content: content,
		imgList: [{
				img: corporateCulture01
			},
			{
				img: corporateCulture02
			},
			{
				img: corporateCulture03
			}
		]
	},
	history: [{
			date: '至今',
			bakImg: courseBackground,
			detail: [{
					item: '敲门砖'
				},
				{
					item: '圣经APP'
				}, {
					item: '福音广告'
				},
				{
					item: 'In Him'
				},
				{
					item: '组长助手'
				}
			]
		},
		{
			date: '2019',
			bakImg: courseBackground,
			detail: [{
					item: '圣经APP问世'
				},
				{
					item: '福音广告开始测试'
				},
				{
					item: '产品技术部成立、更名“因他科技”'
				}
			]
		},
		{
			date: '2018',
			bakImg: courseBackground,
			detail: [{
					item: '附近的教堂小程序首次上线'
				},
				{
					item: '教会通问世'
				},
				{
					item: '恩典365H'
				}
			]
		},
		{
			date: '2013-2017',
			bakImg: courseBackground,
			detail: [{
					item: '主内云团队建立'
				},
				{
					item: '成立媒体部，第一批公众号开始运营'
				}
			]
		}
	]
}
export default data



// WEBPACK FOOTER //
// ./src/common/ter/js/aboutUs.js